import React from 'react'

import logo from '../../assets/logo.svg'

export interface LogoProps {
  size?: number
}

export const Logo: React.FC<LogoProps> = ({
  size = 24
}) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: 99999,
      maxHeight: size,
      maxWidth: size,
      backgroundColor: 'rgba(0,0,0,0)',
    }}
  >
    <img
      src={logo}
      alt="Pollination Logo"
      style={{
        maxHeight: size,
        maxWidth: size,
        backgroundColor: 'rgba(0,0,0,0)',
      }}
    />
  </div>
)

export default Logo
